import { Box, Modal, Typography } from "@mui/material";
import React from "react";
import CloseModalIcon from "../icons/CloseModalIcon";
import PaymentSuccessLine from "./PaymentSuccessLine";
import CustomButton from "../common/CustomButton";
import { getFormattedDateTime } from "../../Utils/helper";

const root = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "90%", // 90% width on extra small screens
    sm: "90%", // 80% width on small screens
    md: "40%", // 60% width on medium screens
    lg: "30%", // 40% width on large screens
  },
  height: {
    xs: "95%", // 90% width on extra small screens
    sm: "80%", // 80% width on small screens
  },
  bgcolor: "#15141B",
  color: "white",
  border: "none",
  boxShadow: 24,
  p: 4,
};

const iconContainer = {
  position: "absolute",
  cursor: "pointer",
  right: { xs: 30, sm: 16 },
  top: { xs: 30, sm: 16 },
  backgroundColor: "transparent",
};

const icon = {
  height: { xs: "12px" },
  width: { xs: "12px" },
};



export default function ModalPaymentSuccess({
  data = {},
  orderId = "",
  type = "payment",
  open = false,
  handleClose = () => {},
}) {
  return (
    <div>
      <Modal
        open={open}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={root} onClick={handleClose}>
          <Box sx={iconContainer}>
            <CloseModalIcon sx={icon} />
          </Box>
          <Box
            onClick={(event) => event.stopPropagation()}
            id="modal-modal-description"
            sx={{
              p: { xs: 1, sm: 5, md: 5 },
              overflowX: "auto",
              height: "90%",
              overFlowX: "auto",
              scrollbarWidth: "none", // Firefox
              "&::-webkit-scrollbar": {
                display: "none", // Chrome, Safari, and Edge
              },
            }}
          >
            <Box
              display="flex"
              justifyContent="center"
              flexDirection="column"
              alignItems="center"
            >
              <img
                width={150}
                height={120}
                src="/images/image/payment-success.png"
                alt="success"
              />
              <Box marginTop={7}>
                <Typography variant="h6" fontWeight={700}>
                  {type === "payment"
                    ? " Payment Success!"
                    : "Withdraw Success!"}
                </Typography>
              </Box>
              <Box
                width="100%"
                marginTop={4}
                marginBottom={4}
                display="flex"
                flexDirection="column"
                gap={1}
              >
                <PaymentSuccessLine label="PaymentID" value={orderId} />
                <PaymentSuccessLine
                  label="Description"
                  value={type === "payment" ? data?.name : "Withdraw"}
                />
                <PaymentSuccessLine
                  label="Date"
                  value={getFormattedDateTime()}
                />
              </Box>
              <CustomButton
                handleClick={() => {
                  handleClose();
                }}
              >
                Done
              </CustomButton>
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
